import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import CyberTrainingCourseTable from "./CyberTrainingCourseTable";

const CoursesModal = (props) => {

	const handleClose = () => {
		props.onClose()
	};
	
	return (
		<Dialog
			open={props.courseStats? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			maxWidth="lg"
		>
			<DialogTitle id="alert-dialog-title">
				Courses:
			</DialogTitle>
			<DialogContent>
				<CyberTrainingCourseTable
					courseStats={props.courseStats}
					showAll={false}
					onCourseClick={props.onCourseClick}
				/>
			</DialogContent>
		</Dialog>
	);

}

export default CoursesModal;